import { Transform, Type } from 'class-transformer';
import { CashReceiptAttachmentRawDto } from './cash-receipt-attachment-raw-dto';
import { GLJournalRawDto } from '../../../../cirabooks-module/_models/general-ledger/gl-journal-raw-dto';
import { PointOfSaleTransactionRawDto } from '../../common/point-of-sale-transaction-raw-dto';
import { CashReceiptItemRawDto } from './cash-receipt-item-raw-dto';
import { dateJSONTransformer } from '../../../../../_constants/validation-format-constants';

export class CashReceiptRawDto {
    cmCashReceiptId: number;
    managementCompanyId: number; // Required
    communityId: number;

    @Type(() => GLJournalRawDto)
    glJournal: GLJournalRawDto;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    receiveDate: Date; // Required

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    postDate: Date; // Required

    payer: string;
    paymentMethod: string;

    @Type(() => PointOfSaleTransactionRawDto)
    pointOfSaleTransactions: PointOfSaleTransactionRawDto[];

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    transactionDate: Date;

    transactionNumber: string;
    isDeposited: boolean;
    amount: number;
    description: string;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    reversedDate: Date;

    customerId: number;

    @Type(() => CashReceiptItemRawDto)
    items: CashReceiptItemRawDto[];

    @Type(() => CashReceiptAttachmentRawDto)
    attachments: CashReceiptAttachmentRawDto[];
}
